/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Usersessionhuburl3Inputs */

const en_entity_usersessionhuburl3 = /** @type {(inputs: Entity_Usersessionhuburl3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Session Hub URL`)
};

const de_entity_usersessionhuburl3 = /** @type {(inputs: Entity_Usersessionhuburl3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Session Hub URL`)
};

/**
* | output |
* | --- |
* | "User Session Hub URL" |
*
* @param {Entity_Usersessionhuburl3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_usersessionhuburl3 = /** @type {((inputs?: Entity_Usersessionhuburl3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Usersessionhuburl3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_usersessionhuburl3(inputs)
	return de_entity_usersessionhuburl3(inputs)
});
export { entity_usersessionhuburl3 as "entity_userSessionHubUrl" }